<script setup lang="ts">
import type { ChooseShippingMethod } from "@/schemas/cart";

const { cart } = useCart();
const { onChooseShippingMethod, isDisabled } = useChooseShippingMethod();

const value = ref<ChooseShippingMethod>(v.parse(chooseShippingMethodSchema, cart.value.shipping));
watch(value, onChooseShippingMethod, { deep: true });
</script>

<template>
  <div>
    <template v-for="(pkg, i) in cart.shipping.packages" :key="i">
      <div v-if="!pkg.available_methods.length" class="text-danger">
        Désolé, aucune méthode d'expédition n'est disponible pour cette adresse de livraison.
      </div>
      <FieldRadioGroup v-model="value.packages[i].selected_method_id" label="Expédition" hide-label :disabled="isDisabled">
        <FieldRadioItem v-for="(method) in pkg.available_methods" :key="method.method_id" :name="`packages.${i}.selected_method`" :value="method.method_id" :label="method.label">
          <div class="inline">
            {{ method.label }} <span class="text-sm text-primary">{{ method.cost ? currency(method.cost) : 'Gratuit' }}</span>
            <a v-if="method.url" :href="method.url" class="link-opacity ml-1.5 inline-flex translate-y-0.5">
              <span class="i-lucide-circle-question-mark size-4 text-primary" />
            </a>
          </div>
        </FieldRadioItem>
      </FieldRadioGroup>
    </template>
  </div>
</template>
